import { CellContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { UpdatedLog } from '@/types/logs'

import styles from './UpdatedRecordsTable.module.scss'

export const DefaultValue = ({ getValue, row, column }: CellContext<UpdatedLog, string | number | string[]>) => {
    const value = getValue()

    const displayedValue = Array.isArray(value) ? value.join(', ') : value

    return (
        <div
            className={clsx(styles.updatedContainer, {
                [styles.updatedHighlighted]: row.original.propertiesChanged?.includes(column.id),
            })}
        >
            {displayedValue || '-'}
        </div>
    )
}
